export const ENGRAVE_FONTS = [
  { id: "display", label: "Elegant Serif", css: "'Cormorant Garamond', serif" },
  { id: "industrial", label: "Industrial", css: "'Oswald', sans-serif" },
  { id: "clean", label: "Modern Sans", css: "'Outfit', sans-serif" },
];

export const PLACEMENTS = [
  { id: "center", label: "Centered" },
  { id: "top", label: "Top" },
  { id: "bottom", label: "Bottom" },
];

export const FINISHES = [
  { id: "etched", label: "Etched Silver", color: "#D8DCE0" },
  { id: "steel", label: "Brushed Steel", color: "#A7ADB4" },
  { id: "graphite", label: "Graphite", color: "#71777E" },
];

export default function LivePreview({ image, customization, shape = "cylinder" }) {
  const { text_lines = [], logo, font = "display", placement = "center", finish = "etched" } =
    customization || {};
  const fontCss = ENGRAVE_FONTS.find((f) => f.id === font)?.css || ENGRAVE_FONTS[0].css;
  const finishColor = FINISHES.find((f) => f.id === finish)?.color || "#D8D8D8";
  const lines = text_lines.filter((l) => String(l).trim());

  const justify =
    placement === "top" ? "flex-start" : placement === "bottom" ? "flex-end" : "center";

  return (
    <div
      data-testid="live-preview"
      className="relative w-full aspect-[4/5] overflow-hidden border border-white/10 bg-[#0d0d0d]"
    >
      {/* ember glow */}
      <div className="absolute inset-0 ember-glow opacity-70" />
      {/* product image */}
      <img
        src={image}
        alt="Product preview"
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/40" />

      {/* engraving zone */}
      <div
        className="absolute inset-0 flex flex-col p-10"
        style={{ justifyContent: justify, alignItems: "center" }}
      >
        <div
          className="flex flex-col items-center gap-3 max-w-[80%]"
          style={{ filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.6))" }}
        >
          {logo && (
            <img
              src={logo}
              alt="logo"
              className="max-h-24 max-w-[60%] object-contain mb-2"
              style={{ filter: "grayscale(1) contrast(1.4) brightness(1.6)", opacity: 0.92 }}
            />
          )}
          {lines.length === 0 && !logo ? (
            <span className="font-body text-xs uppercase tracking-[0.3em] text-muted-foreground">
              Your engraving appears here
            </span>
          ) : (
            lines.map((line, i) => (
              <span
                key={i}
                className="text-center leading-tight break-words"
                style={{
                  fontFamily: fontCss,
                  color: finishColor,
                  fontSize: i === 0 ? "clamp(1.3rem, 3.6vw, 2.4rem)" : "clamp(0.68rem, 1.5vw, 0.95rem)",
                  letterSpacing: font === "industrial" ? "0.12em" : "0.02em",
                  opacity: i === 0 ? 1 : 0.82,
                  maxWidth: i === 0 ? "100%" : "90%",
                  textShadow: "0 0 12px rgba(199,204,210,0.25)",
                }}
              >
                {line}
              </span>
            ))
          )}
        </div>
      </div>

      <div className="absolute bottom-3 left-4 font-num text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
        Live Preview · {shape}
      </div>
    </div>
  );
}
